(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gef-stagione-respiratoria-b-v4"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    const instanceId = root.id.replace('gef-respiratoria-', '');
    if (document.getElementById(root.id) !== root) return;
    if (root.gefRespiratoriaCleanup) root.gefRespiratoriaCleanup();
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const control = root.querySelector('[data-motion-toggle]');
    const tiles = Array.from(root.querySelectorAll('[data-tile]')).map(tile => ({
      images: Array.from(tile.querySelectorAll('.imgs img')),
      dots: Array.from(tile.querySelectorAll('.dots i')),
      label: tile.querySelector('.vlabel span'), index: 0
    })).filter(tile => tile.images.length > 1);
    const chips = Array.from(root.querySelectorAll('.strip span'));
    let chipIndex = 0, paused = false, visible = false, interaction = false;
    let timers = [], observer = null;
    function stop() { timers.forEach(id => { window.clearTimeout(id); window.clearInterval(id); }); timers = []; }
    function show(tile, index) {
      tile.index = index;
      tile.images.forEach((image, position) => image.classList.toggle('is-on', position === index));
      tile.dots.forEach((dot, position) => dot.classList.toggle('is-on', position === index));
      if (tile.label) tile.label.textContent = tile.images[index].getAttribute('data-label') || '';
    }
    function sync() {
      stop();
      control.hidden = motion.matches;
      control.setAttribute('aria-pressed', String(paused));
      control.textContent = paused ? 'Riprendi le immagini' : 'Metti in pausa le immagini';
      if (motion.matches) {
        tiles.forEach(tile => show(tile, 0));
        chips.forEach((chip, index) => chip.classList.toggle('is-on', index === 0));
        return;
      }
      if (paused || !visible || interaction || document.hidden) return;
      tiles.forEach((tile, index) => timers.push(window.setTimeout(() => {
        show(tile, (tile.index + 1) % tile.images.length);
        timers.push(window.setInterval(() => show(tile, (tile.index + 1) % tile.images.length), 3400));
      }, 1700 + index * 1100)));
      if (chips.length > 1) timers.push(window.setInterval(() => {
        chipIndex = (chipIndex + 1) % chips.length;
        chips.forEach((chip, index) => chip.classList.toggle('is-on', index === chipIndex));
      }, 1800));
    }
    const toggle = () => { paused = !paused; sync(); };
    const enter = () => { interaction = true; sync(); };
    const leave = event => { interaction = root.contains(document.activeElement) || root.contains(event.relatedTarget); sync(); };
    const focusOut = event => { interaction = root.contains(event.relatedTarget); sync(); };
    const unload = event => { if (event.detail && event.detail.sectionId === instanceId) cleanup(); };
    function cleanup() {
      stop(); if (observer) observer.disconnect();
      control.removeEventListener('click', toggle);
      root.removeEventListener('mouseenter', enter); root.removeEventListener('mouseleave', leave);
      root.removeEventListener('focusin', enter); root.removeEventListener('focusout', focusOut);
      document.removeEventListener('visibilitychange', sync); document.removeEventListener('shopify:section:unload', unload);
      motion.removeEventListener('change', sync); delete root.gefRespiratoriaCleanup;
    }
    root.gefRespiratoriaCleanup = cleanup;
    control.addEventListener('click', toggle);
    root.addEventListener('mouseenter', enter); root.addEventListener('mouseleave', leave);
    root.addEventListener('focusin', enter); root.addEventListener('focusout', focusOut);
    document.addEventListener('visibilitychange', sync); document.addEventListener('shopify:section:unload', unload);
    motion.addEventListener('change', sync);
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, {threshold: 0.15});
      observer.observe(root);
    } else { visible = true; }
    sync();
  }
  document.querySelectorAll('[data-gef-respiratoria]').forEach(init);
  document.addEventListener('shopify:section:load', function onLoad(event) {
    if (!(event.target instanceof Element)) return;
    if (event.target.matches('[data-gef-respiratoria]')) init(event.target);
    event.target.querySelectorAll('[data-gef-respiratoria]').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
